var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('span',{staticClass:"required"},[_c('v-icon',{attrs:{"color":"red","x-small":""}},[_vm._v(_vm._s(_vm.iconRequired))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }